import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'

import { ApiOrder, ApiOrderShort } from '@/types'

type State = {
  tableOrdersForWidget: ApiOrderShort[]
  totalOpenOrders: number
  documentTypes: string
}

type Actions = {
  getOrderDetails: (orderCode: string) => Promise<ApiOrder>
  getOrdersForWidget: () => Promise<void>
  resetState: () => void
}

export const useOrdersStore = defineStore<string, State, Record<string, never>, Actions>('orders', {
  state: () => ({
    tableOrdersForWidget: [],
    totalOpenOrders: 0,
    documentTypes: 'INVOICES,PACKING_LISTS,RMA,PROJECT_BRIEFS',
  }),

  actions: {
    async getOrderDetails(orderCode) {
      const { data: orderDetailsData } = await api.orders.getOrderById(orderCode)
      return orderDetailsData
    },

    async getOrdersForWidget() {
      const response = await api.orders.getOrders({
        sort: 'byDateDESC',
        pageSize: 5,
        statuses: 'Partially Shipped,Processing',
        orderDocumentTypes: this.documentTypes,
        statisticsByStatuses: true,
        showCompanyOrders: true,
      })
      const { orders = [], statisticsByStatuses = [] } = response.data
      const totalPartiallyShippedOrders =
        statisticsByStatuses.find((el) => el.name === 'Partially Shipped')?.count || 0
      const totalProcessingOrders =
        statisticsByStatuses.find((el) => el.name === 'Processing')?.count || 0
      const totalOpenOrders = totalPartiallyShippedOrders + totalProcessingOrders
      this.tableOrdersForWidget = orders
      this.totalOpenOrders = totalOpenOrders
    },

    resetState() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOrdersStore, import.meta.hot))
}
